import { render, staticRenderFns } from "./yonyouMerchant_list.vue?vue&type=template&id=12d74166&scoped=true"
import script from "./yonyouMerchant_list.vue?vue&type=script&lang=js"
export * from "./yonyouMerchant_list.vue?vue&type=script&lang=js"
import style0 from "./yonyouMerchant_list.vue?vue&type=style&index=0&id=12d74166&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d74166",
  null
  
)

export default component.exports